import { FooterLogos } from "@shared/components/AuthFooter/FooterLogos/FooterLogos";
import { FooterPrivacy } from "@shared/components/AuthFooter/FooterPrivacy/FooterPrivacy";
import { useFlippers } from "@shared/context/FlippersContext";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { DeliveryCountry } from "@unauthenticated/signupSignin/components/DeliveryCountry/DeliveryCountry";

import { footer, footerLogos, privacyPolicy } from "./StoreLandingFooter.styles";

interface Props {
  showDeliveryCountry?: boolean;
}

const StoreLandingFooter = ({ showDeliveryCountry }: Props) => {
  const { phoneLarge } = useBreakpoints();
  const [isQualityStorySignupEnabled] = useFlippers("platypus_quality_story_signup");
  const { isUS } = useSharedGlobalConfig();

  const isDeliveryCountryVisible = !!showDeliveryCountry && isQualityStorySignupEnabled && isUS;

  return (
    <div css={theme => footer(theme, isDeliveryCountryVisible)}>
      <div css={!!phoneLarge.greaterThan && footerLogos}>
        <FooterLogos />
      </div>
      <div css={privacyPolicy(isDeliveryCountryVisible)}>
        <FooterPrivacy />
      </div>
      {!!isDeliveryCountryVisible && <DeliveryCountry />}
    </div>
  );
};

export { StoreLandingFooter };
